import { Button, Col, Divider, Form, Input, Radio, Row } from 'antd'
import _ from 'lodash'
import React, { useState } from 'react'
import { useDeepEffect } from '../../../../utils/hooks'

const LocationForm = (props) => {
  const { form, hero, onClose, heroConfig, locationList, onSaveLocation } =
    props
  const { validateFields, getFieldDecorator } = form

  const [locations, setLocations] = useState([])

  useDeepEffect(() => {
    if (!_.isEmpty(hero)) {
      form.setFieldsValue({
        maxLocation: hero.maxLocation,
        radius: hero.radius,
        configByHero: hero.configByHero
      })
    }
  }, [hero])

  useDeepEffect(() => {
    if (!_.isNull(locationList)) {
      if (!_.isUndefined(locationList)) {
        setLocations((prevState) => {
          for (let i = 0; i < hero.maxLocation; i++) {
            const result = _.find(locationList, (location, index) => {
              return index === i
            })

            if (!_.isUndefined(result)) {
              prevState.push(result)
            } else {
              prevState.push({
                address: '',
                id: 0,
                lat: '',
                lng: ''
              })
            }
          }
          return [...prevState]
        })
      }
    }
  }, [locationList])

  useDeepEffect(() => {
    if (!_.isEmpty(locations)) {
      if (!_.isNull(hero.configByHero)) {
        if (hero.configByHero) {
          form.setFieldsValue({
            maxLocation: hero.maxLocation,
            radius: hero.radius,
            configByHero: hero.configByHero
          })
          locations.forEach((item, index) => {
            form.setFieldsValue({
              [`address_${index}`]: item.address,
              [`lat_${index}`]: item.lat,
              [`lng_${index}`]: item.lng
            })
          })
        } else {
          if (heroConfig) {
            form.setFieldsValue({
              maxLocation: heroConfig.locationCount,
              radius: heroConfig.radius,
              configByHero: false
            })
          }
          locations.forEach((item, index) => {
            form.setFieldsValue({
              [`address_${index}`]: item.address,
              [`lat_${index}`]: item.lat,
              [`lng_${index}`]: item.lng
            })
          })
        }
      } else {
        if (heroConfig) {
          form.setFieldsValue({
            maxLocation: heroConfig.locationCount,
            radius: heroConfig.radius,
            configByHero: false
          })
        }
        locations.forEach((item, index) => {
          form.setFieldsValue({
            [`address_${index}`]: item.address,
            [`lat_${index}`]: item.lat,
            [`lng_${index}`]: item.lng
          })
        })
      }
    }
  }, [locations, heroConfig, hero])

  const addLocation = (e) => {
    e.preventDefault()
    setLocations((prevState) => {
      prevState.push({
        address: '',
        id: 0,
        lat: '',
        lng: ''
      })
      return [...prevState]
    })
  }

  const removeLocation = (e, index) => {
    e.preventDefault()
    setLocations((prevState) => {
      _.remove(prevState, (item, idx) => {
        return idx === index
      })
      return [...prevState]
    })
  }

  const onChangeConfig = async (e) => {
    setLocations([])
    if (e.target.value) {
      await form.setFieldsValue({
        maxLocation: hero.maxLocation,
        radius: hero.radius,
        configByHero: e.target.value
      })

      setLocations((prevState) => {
        for (let i = 0; i < hero.maxLocation; i++) {
          const result = _.find(locationList, (location, index) => {
            return index === i
          })

          if (!_.isUndefined(result)) {
            prevState.push(result)
          } else {
            prevState.push({
              address: '',
              id: 0,
              lat: '',
              lng: ''
            })
          }
        }
        return [...prevState]
      })
    } else {
      await setLocations((prevState) => {
        for (let i = 0; i < heroConfig.locationCount; i++) {
          const result = _.find(locationList, (location, index) => {
            return index === i
          })

          if (!_.isUndefined(result)) {
            prevState.push(result)
          } else {
            prevState.push({
              address: '',
              id: 0,
              lat: '',
              lng: ''
            })
          }
        }
        return [...prevState]
      })

      await form.setFieldsValue({
        maxLocation: heroConfig.locationCount,
        radius: heroConfig.radius,
        configByHero: e.target.value
      })
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          configByHero: values.configByHero,
          heroId: hero.id,
          maxLocation: Number(values.maxLocation),
          radius: Number(values.radius),
          locationList: []
        }

        locations.forEach((item, index) => {
          data.locationList.push({
            address: values[`address_${index}`],
            id: item.id,
            lat: values[`lat_${index}`],
            lng: values[`lng_${index}`]
          })
        })

        await onSaveLocation(data)
        await setLocations([])
        await onClose()
      }
    })
  }

  return (
    <Form layout="inline" onSubmit={handleSubmit} style={{ padding: '1rem' }}>
      <Row>
        <Col span={24}>
          <Form.Item label="จำนวน Location">
            {getFieldDecorator(`maxLocation`, {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก'
                }
              ]
            })(<Input type="number" min={1} style={{ width: '250px' }} />)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="รัศมีของ Location (เมตร)">
            {getFieldDecorator(`radius`, {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก'
                }
              ]
            })(<Input type="number" min={1} style={{ width: '250px' }} />)}
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item label="Config By Hero">
            {getFieldDecorator(`configByHero`, {
              initialValue: false,
              rules: [
                {
                  required: true,
                  message: 'กรุณาเลือก'
                }
              ]
            })(
              <Radio.Group onChange={onChangeConfig}>
                <Radio value={true}>Enable</Radio>
                <Radio value={false}>False</Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Row type="flex" justify="end">
            <Form.Item>
              <Button onClick={(e) => addLocation(e)}>เพิ่ม Location</Button>
            </Form.Item>
          </Row>
        </Col>
      </Row>
      <Divider style={{ margin: '10px 0' }} />
      {!_.isEmpty(locations) &&
        locations.map((location, index) => {
          return (
            <div key={index}>
              <Row>
                <Col span={12}>
                  <span>{`Location ที่ ${index + 1}`}</span>
                </Col>
                <Col span={12}>
                  <Row type="flex" justify="end">
                    <Button
                      type="danger"
                      onClick={(e) => removeLocation(e, index)}>
                      ลบ
                    </Button>
                  </Row>
                </Col>
              </Row>
              <Row gutter={8}>
                <Col span={12}>
                  <Form.Item label="ละติจูด">
                    {getFieldDecorator(`lat_${index}`, {
                      initialValue: location.lat
                    })(<Input style={{ width: '250px' }} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="ลองติจูด">
                    {getFieldDecorator(`lng_${index}`, {
                      initialValue: location.lng
                    })(<Input style={{ width: '250px' }} />)}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="ที่อยู่">
                    {getFieldDecorator(`address_${index}`, {
                      initialValue: location.address
                    })(<Input.TextArea rows={2} style={{ width: '640px' }} />)}
                  </Form.Item>
                </Col>
              </Row>
              <Divider style={{ margin: '10px 0' }} />
            </div>
          )
        })}
      <Row type="flex" justify="end" style={{ marginTop: 15 }}>
        <Button type="primary" htmlType="submit">
          Save Location
        </Button>
      </Row>
    </Form>
  )
}

const WrappedLocationForm = Form.create({ name: 'LocationForm' })(LocationForm)

export default WrappedLocationForm
